// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__hARVA","title":"NotFound_title__htZJO","text":"NotFound_text__EcWFE","image":"NotFound_image__NR7nB"};